export default "__VITE_ASSET__BqzZmcBp__"